export type EmptyContentInput = string | null | undefined;

/**
 * Treats these values as "no content":
 * - null / undefined
 * - "" (after trim / HTML strip)
 * - "." (after trim / HTML strip)
 * - ".." (after trim / HTML strip)
 * - "-" (after trim / HTML strip)
 */
export function isEmptyContent(value: EmptyContentInput) {
  if (value == null) return true;

  const stripped = value
    // remove HTML tags
    .replace(/<[^>]*>/g, "")
    // normalize common HTML whitespace entities
    .replace(/&nbsp;|&#160;/gi, " ")
    // remove zero-width chars
    .replace(/[\u200B-\u200D\uFEFF]/g, "")
    .trim();

  return (
    stripped === "" || stripped === "." || stripped === ".." || stripped === "-"
  );
}
